module.exports = __webpack_public_path__ + "static/media/rotini.074f0c92.png";